

import { RequestConsignee  } from '../../../../requestDetailEdit/models/requestConsignee';

export interface IConsigneeService {
    getConsigneeDetails(searchTerm: string): ng.IPromise<RequestConsignee[]>;
}

export class ConsigneeService implements IConsigneeService {

    static $inject = ['$http'];

    constructor(private _$http: ng.IHttpService) { }

    getConsigneeDetails(searchTerm: string): ng.IPromise<RequestConsignee[]> {
        return this._$http.get<RequestConsignee[]>(`/getConsignee?searchTerm=${searchTerm}&currentPageNumber=1&numberOfItemsPerPage=1000`).then(response => {
            return response.data;
        });
    }
}

angular
    .module('deliveryCreate.app')
    .service('ConsigneeService', ConsigneeService);



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/addRequest/directives/consigneeSearch/services/consigneeService.ts
 **/